import React from 'react'
import { graphql } from 'gatsby'

// Components
import Seo from '../components/Seo'
import Layout from '../components/Layout'
import Intro from '../components/Intro'
import PreviewPost from '../components/PreviewPost'

const Home = ({ data }) => {
  const posts = data.allMdx.nodes

  return (
    <>
      <Layout>
        <Seo title={`Home`} />
        <Intro />
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10 mx-auto">
              {posts.map(post => {
                return <PreviewPost key={post.id} post={post} />
              })}
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  {
    allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      limit: 8
      filter: { fileAbsolutePath: { regex: "/blog/" } }
    ) {
      nodes {
        id
        frontmatter {
          title
          category
          date
          description
          slug
        }
        timeToRead
      }
    }
  }
`

export default Home
